import styled from 'styled-components'

import { PriceStyled } from '@webapp/core/components/Price/styles/PriceStyled'

export const BudgetCategoryCardGranularSpendStyled = styled.div`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  padding: ${(props) => props.theme.typography.pxToRem(16)}
    ${(props) => props.theme.typography.pxToRem(24)};
  border-top: 1px solid ${(props) => props.theme.colors.lightGrey};
  background: ${(props) => props.theme.colors.offwhite};

  ${PriceStyled} {
    display: inline;
  }
`
